var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClipboardPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.767 2.11621H116.237C114.807 2.11621 113.648 3.27507 113.648 4.70459V9.88135C113.648 11.3109 114.807 12.4697 116.237 12.4697H131.767C133.197 12.4697 134.355 11.3109 134.355 9.88135V4.70459C134.355 3.27507 133.197 2.11621 131.767 2.11621Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.354 7.29297H139.53C140.903 7.29297 142.22 7.83838 143.191 8.80921C144.162 9.78004 144.707 11.0968 144.707 12.4697V48.707C144.707 50.08 144.162 51.3967 143.191 52.3676C142.22 53.3384 140.903 53.8838 139.53 53.8838H108.47C107.097 53.8838 105.78 53.3384 104.809 52.3676C103.838 51.3967 103.293 50.08 103.293 48.707V12.4697C103.293 11.0968 103.838 9.78004 104.809 8.80921C105.78 7.83838 107.097 7.29297 108.47 7.29297H113.646M116.235 33.1768H131.765M124 40.9419V25.4116",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardPlus);
export default __webpack_public_path__ + "static/media/icon-clipboard-plus.a43d2855acabaada0965fcabdee2d48f.svg";
export { ForwardRef as ReactComponent };